module.exports = __webpack_public_path__ + "static/media/logo_light_new.5f4d575a.svg";